import React, { Component, useState, useEffect } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

//Ruler img
import mdasi_grey from '../../Images/Healthform/health_grey.png';
import mdasi_green from '../../Images/Healthform/health_green.png';
import mdasi_orange from '../../Images/Healthform/health_orange.png';
import mdasi_red from '../../Images/Healthform/health_red.png';

class MDASIDisplay extends Component {
    //Function to display form mdasi alert logo with the good color
    getFormImg(){
        if(this.props.formresmdasiDisplay.color === "#21BA45"){
            //return green
            return (<img src={mdasi_green} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="mdasi_logo"/>)
        }
        else if(this.props.formresmdasiDisplay.color === "#F2711C"){
            //return orange
            return (<img src={mdasi_orange} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="mdasi_logo"/>)
        }
        else if(this.props.formresmdasiDisplay.color === "#DB2828"){
            //return orange
            return (<img src={mdasi_red} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="mdasi_logo"/>)
        }
        else{
            //return grey
            return (<img src={mdasi_grey} style={{ height: "auto", maxHeight: "100%", width: "auto", maxWidth: "55px"}} alt="mdasi_logo"/>)
        }
    }

    display_value(){

        let unit = ""

        return(
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%", paddingBottom:"5%"}}>
                {
                    this.getFormImg()
                }
            </Row>
        )
    }

    //Display render
    render(){
        return (
            <div>
                <Col>
                    {this.display_value()}
                </Col>
            </div>
        );
    }
}
export default (MDASIDisplay);